import { ApplicationState } from "app/types-store";
import { ActionDispatching, StoreField } from "app/types-shared";
import { api } from "./api";
import { actionCreators as caseCreateActionCreators } from "app/area/case/create/actions";
import { api as caseCreateApi } from "app/area/case/create/api";
import { CaseDraftParameter, RunAgUiArgs } 
from "app/components/ai-chat-assistant/types";
import {
  RequestAiAssistantRun,
  FailAiAssistantRun,
  FinishAiAssistantRun,
  RequestCreateDraft,
  FinishCreateDraft,
  FailCreateDraft
} from "./action-types";
import { AiAssistantActionMiddleware } from "app/components/ai-chat-assistant/hooks/ai-assistant-action-middleware";
import { actionCreators as draftCaseActionCreators } from 'app/area/case/draft/actions';
import { getDraftId } from "app/infrastructure/store/query";

export const actionCreators = {
  createCaseDraft:
    (
      query: CaseDraftParameter[],
      caseTypeId: number
    ): ActionDispatching<any, ApplicationState> =>
    async (dispatch) => {
      dispatch(new RequestCreateDraft());

      try {
        await dispatch(
          caseCreateActionCreators(caseCreateApi).createCase(
            caseTypeId,
            null,
            null,
            null,
            query
          )
        );
        dispatch(new FinishCreateDraft());
      } catch (error: unknown) {
        const message = error instanceof Error ? error.message : String(error);
        dispatch(new FailCreateDraft(message));
      }
    },

  abortAiAssistantRun:
    (): ActionDispatching<any, ApplicationState> => (dispatch) => {
      dispatch(new FinishAiAssistantRun());
    },

  executeAiAssistantRun:
    (args: RunAgUiArgs): ActionDispatching<any, ApplicationState> =>
    async (dispatch, getState) => {
      dispatch(new RequestAiAssistantRun());
      const draftId = getDraftId(getState()?.caseArea?.editing?.values);
      if (draftId) {
        args = {
          ...args,
          context: [
            ...args.context,
            { description: "caseDraftId", value: String(draftId) }
          ]
        };
      }
      
      try {
        const middleware = new AiAssistantActionMiddleware(dispatch);
        await api.executeAiAssistantRun({
          ...args,
          middlewares: [middleware]
        });
      } catch (error: unknown) {
        const message = error instanceof Error ? error.message : String(error);
        dispatch(new FailAiAssistantRun(message));
      }
    },

  updateCaseDraft:
    (
      dataTag: string,
      values: StoreField[]
    ): ActionDispatching<any, ApplicationState> =>
    async (dispatch, getState: () => ApplicationState) => {
      const stateValues = getState().caseArea.editing.values?.[0];
      await dispatch(
        draftCaseActionCreators.valueChanged(
          stateValues.id,
          dataTag,
          values,
          true
        )
      );
    }
};
